module.exports = __webpack_public_path__ + "img/logo_icon_branco.fbb1e921.png";